export default __webpack_public_path__ + "curve-section-footer.a68d7b.svg";